import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <section className="footer-2">
      <div className="w-layout-grid footer-grid grid-3">
        <div
          id="w-node-fa81bc58-9989-5b16-a9ea-c39ea8429d1c-a8429d1a"
          className="footer-block"
        >
          <Link to="/" className="footer-brand margin-top-20 w-inline-block">
            <img
              width={32}
              loading="lazy"
              alt=""
              src="/images/hobi-white.svg"
              className="image-49"
            />
          </Link>
          <p className="body-text">
            Hobi - A go-to platform to discover curated activities that match your
            interests, mood, and vibe. Whether you're looking to create, perform,
            play, move, cook, learn, or explore the outdoors — Hobi helps you
            break out of routine and dive into experiences that feel truly you.
            Just show up, we've got the rest covered.
          </p>
          <div className="footer-nav margin-top-desktop-40">
            <Link to="/about" className="footer-link">
              About
            </Link>
            <Link
              to="/faq"
              className="footer-link margin-left-desktop-20 margin-top-mobile-10"
            >
              Faq's
            </Link>
            <Link
              to="/contact"
              className="footer-link margin-left-desktop-20 margin-top-mobile-10"
            >
              Contact
            </Link>

            <Link
              to="/help"
              className="footer-link margin-left-desktop-20 margin-top-mobile-10"
            >
              Help
            </Link>
            <Link
              to="/privacy"
              className="footer-link margin-left-desktop-20 margin-top-mobile-10"
            >
              Privacy
            </Link>
          </div>
        </div>
        <div
          id="w-node-fa81bc58-9989-5b16-a9ea-c39ea8429d2e-a8429d1a"
          className="footer-block top-margin-mobile-80"
        >
          <h4 className="footer-heading">Get Social</h4>
          <p className="get-the-app-desc">
            Experience and discover curated activities that match your interests
          </p>
          <div className="socialmedia-ico">
            <a
              href="https://www.instagram.com/everythinghobi?igsh=MXEyaWxkaXIzeGhlcQ%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link social-media-link"
            >
              Instagram
            </a>

            <a
              href="https://www.linkedin.com/company/hobihubservices/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link social-media-link"
            >
              Linkedin
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="body-text">
          © 2026 Hobihub Services Private Limited | Designed by{" "}
          <a href="https://kwad.in" className="link" target="_blank" rel="noopener noreferrer">
            Kwad
          </a>
        </p>
        <Link to="/terms" className="footer-link margin-top-mobile-10">
          Terms of service
        </Link>
      </div>
    </section>
  );
};
